export const FilterBoxOptions = {
'default': [
    {label: "Gender", value: {type: "gender", query: "Users"}},
    {label: "Education Level", value: {type: "education", query: "Users"}},
    {label: "Border Crossing Frequency", value: {type: "crossing_freq", query: "Users"}},
    {label: "Age", value: {type: "age", query: "Users"}},
    {label: "Country of Residence", value: {type: "country_of_residence", query: "Users"}},
    {label: "Primary Income", value: {type: "primary_income", query: "Users"}},
    {label: "Language", value: {type: "language", query: "Users"}},
    {label: "Produce", value: {type: "produce", query: "Users"}},
    {label: "Most Requested Procedures Commodities", value: {type: 'procedurecommodity',  query: "Sessions"}},
    {label: "Most Requested Procedure Commodity Categories", value: {type: "procedurecommoditycat", query: "Sessions"}},
    {label: "Requested Procedures for Destination (Imports to:)", value: {type: "proceduredest", query: "Sessions"}},
    {label: "Most Requested Document Information for Procedures", value: {type: "procedurerequireddocument", query: "Sessions"}},
    {label: "Most Requested Agency Information for Procedures", value: {type: "procedurerelevantagency", query: "Sessions"}},
    {label: "Origin of Traders' Goods", value: {type: "procedureorigin", query: "Sessions"}},
    {label: "Final Destination Country", value: {type: "commoditycountry", query: "Sessions"}},
    {label: "Final Destination Market", value: {type: "commoditymarket", query: "Sessions"}},
    {label: "Top Commodity", value: {type: "commodityproduct", query: "Sessions"}},
    {label: "Top Commodity Categories", value: {type: "commoditycat", query: "Sessions"}},
    {label: "Exchange Rate Direction", value: {type: "exchangedirection", query: "Sessions"}}
    ],
'filtered': [
    {label: "Gender", value: {type: "gender", query: "Users"}},
    {label: "Education Level", value: {type: "education", query: "Users"}},
    {label: "Border Crossing Frequency", value: {type: "crossing_freq", query: "Users"}},
    {label: "Age", value: {type: "age", query: "Users"}},
    {label: "Country of Residence", value: {type: "country_of_residence", query: "Users"}},
    {label: "Primary Income", value: {type: "primary_income", query: "Users"}},
    {label: "Language", value: {type: "language", query: "Users"}},
    {label: "Produce", value: {type: "produce", query: "Users"}},
    ]
};

